/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { mobileOrderItemCreateSchema } from "./mobileOrderItemCreateSchema.ts";

export const mobileOrderExtendSchema = z.object({
	items: z.array(mobileOrderItemCreateSchema),
	table: z.uuid().nullable(),
});
